import Seo from "@/components/Seo";
import React from "react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import {
  WhyHero, Heading, Reveal, IconCardGrid, LabelChips, WhyFinalCTA,
  PaymentPageMock,
} from "@/components/why/WhyParts";
import { CUSTOMER_SEE, CUSTOMER_PROTECT, CUSTOMER_FAQS } from "@/data/content";

export default function CustomerProtection() {
  return (
    <main>
      <Seo path="/why-workpay/customer-protection" />
      <WhyHero
        eyebrow="Customer Protection"
        title={<>Pay with clarity, <span className="text-gradient">not blind trust.</span></>}
        subtitle="Workpay helps customers see project terms, track milestones, approve progress, and raise issues clearly."
        primaryLabel="See How Workpay Works"
        primaryHow
        visual={<PaymentPageMock />}
      />

      <section className="py-16 sm:py-24 bg-[#f7faf8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal><Heading overline="Before you pay" title="What customers see before paying" /></Reveal>
          <LabelChips items={CUSTOMER_SEE} />
        </div>
      </section>

      <section className="py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal><Heading overline="Protection" title="How Workpay helps customers stay protected" /></Reveal>
          <IconCardGrid items={CUSTOMER_PROTECT} />
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-[#f7faf8]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Reveal>
            <Heading
              overline="Balanced by design"
              title="Vendor-first, but not customer-risky."
              subtitle="Vendors use Workpay to create payment clarity. Customers use Workpay to understand what they are paying for and how project progress will be tracked."
            />
          </Reveal>
        </div>
      </section>

      <section className="py-16 sm:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal><Heading overline="FAQ" title="Customer questions, answered." /></Reveal>
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="mt-10 space-y-3" data-testid="customer-faq-accordion">
              {CUSTOMER_FAQS.map((faq, i) => (
                <AccordionItem
                  key={i}
                  value={`c-item-${i}`}
                  data-testid={`customer-faq-item-${i}`}
                  className="rounded-2xl border border-slate-100 bg-white px-5 soft-shadow"
                >
                  <AccordionTrigger className="text-left text-[#091630] font-bold hover:no-underline hover:text-[#16a34a] py-5">
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-500 text-[15px] leading-relaxed pb-5">
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>

      <WhyFinalCTA
        title={<>A clearer way to pay for <span className="text-[#21c55e]">service projects.</span></>}
        primaryLabel="Learn How It Works"
        primaryHow
        secondaryLabel={null}
      />
    </main>
  );
}
